/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Divider, Grid, Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/coding-challenges';

import TrophySVG from './TrophySVG';

const styles = {
  titleText: css`
    margin-bottom: 40px;
  `,
  rewardsCard: css`
    padding: 20px;
    width: 31%;
    border-radius: 10px;
    background: linear-gradient(180deg, #0056d2 0%, #76acf9 100%);
    height: 318px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
  cardText: css`
    text-align: center;
    color: #fff;
    padding: 15px;
  `,
  gridItemColor: css`
    background-color: #0056d2;
  `,
  gridContainer: css`
    align-items: center;
    text-align: left;
    justify-content: center;
    width: 100%;
  `,
  cardsCenter: css`
    justify-content: space-between;
    width: 100%;
  `,
  SVGStyle: css`
    align-self: center;
  `,
};

const LandingPageRewards = () => {
  return (
    <div css={styles.gridContainer}>
      <Typography variant="h1semibold">{_t('Rewards')}</Typography>
      <Typography2 component="p" css={styles.titleText} variant="bodyPrimary">
        {_t('By competing, you have the chance to win the following prizes:')}
      </Typography2>
      {/* Make the dividers aligned for all 3 cards */}
      <Grid container css={styles.cardsCenter}>
        <Grid item css={styles.rewardsCard}>
          <div css={styles.SVGStyle}>
            <TrophySVG />
          </div>
          <Typography css={styles.cardText} variant="h2semibold">
            {_t('Top 15')}
          </Typography>
          <Divider color="white" />
          <Typography2 component="p" css={styles.cardText} variant="bodyPrimary">
            {_t(
              'The top 15 performers will have an exclusive Q&A session with a Data Science Manager, where they can discuss the future of Gen AI and gain valuable insights on becoming job-ready in this era.'
            )}
          </Typography2>
        </Grid>
        <Grid item css={styles.rewardsCard}>
          <div css={styles.SVGStyle}>
            <TrophySVG />
          </div>
          <Typography css={styles.cardText} variant="h2semibold">
            {_t('Top 100')}
          </Typography>
          <Divider />
          <Typography2 component="p" css={styles.cardText} variant="bodyPrimary">
            {_t(
              'The top 100 performers will get complimentary access to select Data Science courses on Coursera.                    '
            )}
          </Typography2>
        </Grid>
        <Grid item css={styles.rewardsCard}>
          <div css={styles.SVGStyle}>
            <TrophySVG />
          </div>
          <Typography css={styles.cardText} variant="h2semibold">
            {_t('Top 20%')}
          </Typography>
          <Divider />
          <Typography2 component="p" css={styles.cardText} variant="bodyPrimary">
            {_t(
              'Participants based in the US and India ranking in the top 20% will earn an achievement badge on their Coursera Skills Profile.'
            )}
          </Typography2>
        </Grid>
      </Grid>
    </div>
  );
};

export default LandingPageRewards;
